import { useState, useEffect, MouseEvent, useCallback, ReactElement } from 'react'
import { IconButton, Menu, MenuItem, TextField } from "@mui/material";
import DotsVertical from 'mdi-material-ui/DotsVertical'
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import SendIcon from '@mui/icons-material/Send';
import LockResetIcon from '@mui/icons-material/LockReset';
import DoneIcon from '@mui/icons-material/Done';
import CancelIcon from '@mui/icons-material/Cancel';
import { Sprint } from '../../stores/SprintStore';
import PencilOutline from 'mdi-material-ui/PencilOutline'

type Props = {
    id: string,
    status: string,
    onEdit: (row: Sprint) => void,
    onToggleActive: (row: Sprint) => void,
    row: Sprint
}

const SprintRowOptions = ({ id, status, onEdit, onToggleActive, row }: Props) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const [changePasswordOpen, setChangePasswordOpen] = useState(false);
    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState(false);
    const rowOptionsOpen = Boolean(anchorEl)

    const handleRowOptionsClose = () => {
        setAnchorEl(null)
    }

    const toggleActive = async (e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        e.preventDefault();
        onToggleActive(row);
        handleRowOptionsClose()
    }

    const edit = async (e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        e.preventDefault();
        onEdit(row);
        handleRowOptionsClose();
    }

    return (
        <>            
            <IconButton onClick={edit} title="Edit">
                <PencilOutline fontSize='small' sx={{ mr: 2 }} />
            </IconButton>
        </>
    )
}

export { SprintRowOptions }
export default SprintRowOptions;